// Required data references only. Never implicitly select document history or files.
const dependencies = {
  company: ['plans'], counters: ['resolutions'],
  issuedHistory: ['invoiceSoftware', 'relatedCustomers', 'resolutions'],
  payrollHistory: ['payrollSoftware', 'employees', 'resolutions'],
  establishments: ['resolutions']
};
export function completeSelection(selection) {
  const result = new Set(selection);
  const add = key => (dependencies[key] || []).forEach(dependency => { if (!result.has(dependency)) { result.add(dependency); add(dependency); } });
  [...result].forEach(add); return [...result];
}
export function removeSelection(selection, removed) {
  const result = new Set(selection); removed.forEach(key => result.delete(key));
  let changed = true;
  while (changed) { changed = false; [...result].forEach(key => { if ((dependencies[key] || []).some(d => !result.has(d))) { result.delete(key); changed = true; } }); }
  return [...result];
}
